import * as yup from 'yup';
import { Row, Column, EMPTY_ARRAY, RenderConfig, SelectInput, TextInput } from 'commons-ui';
import { IS_ACTIVE_OPTIONS } from './constants';

export const FORM_FIELD_KEYS = {
	IS_ACTIVE: 'isActive',
	SMS_MESSAGE: 'smsMessage',
	TITLE: 'title',
	USER_TEXT: 'userText',
	IS_PG_ERROR: 'isPGError',
	DELINK: 'delink',
	INSTANT_FAILURE: 'instantFailure',
	USER_FAILURE_MESSAGE: 'userFailureMessage'
};

export const FORM_LAYOUT_EDIT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.SMS_MESSAGE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.TITLE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.USER_TEXT)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.USER_FAILURE_MESSAGE)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.INSTANT_FAILURE)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.DELINK)]), new Column([new Row(FORM_FIELD_KEYS.IS_PG_ERROR)])])
];

export const FORM_FIELD_EDIT_CONFIG = {
	[FORM_FIELD_KEYS.SMS_MESSAGE]: new RenderConfig()
		.setName('smsMessage')
		.setLabel('SMS Message')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.TITLE]: new RenderConfig()
		.setName('title')
		.setLabel('Title')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.IS_ACTIVE]: new RenderConfig()
		.setName('isActive')
		.setLabel('Is Active')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: IS_ACTIVE_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.USER_TEXT]: new RenderConfig()
		.setName('userText')
		.setLabel('User Text')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.USER_FAILURE_MESSAGE]: new RenderConfig()
		.setName('userFailureMessage')
		.setLabel('User Failure Message')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.IS_PG_ERROR]: new RenderConfig()
		.setName('isPGError')
		.setLabel('Is PG Error')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: IS_ACTIVE_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.DELINK]: new RenderConfig()
		.setName('delink')
		.setLabel('Delink')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: IS_ACTIVE_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.INSTANT_FAILURE]: new RenderConfig()
		.setName('instantFailure')
		.setLabel('Instant Failure')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: IS_ACTIVE_OPTIONS,
			required: true
		})
};

export const validationSchema = yup.object().shape({
	message: yup
		.string()
		.test('len', 'Message should be of appropriate length!', (val) => !val || val.length > 1 || val.length < 50)
		.optional()
});
